import { TranslateFunc } from 'components/translate/src/translate-func';
import { ClientMarket } from 'config/types/client-market';

type VariantSelection = string[] | null;

export const getSizeTitle = (t: TranslateFunc, market: ClientMarket) => {
  return `${t('product', 'label.size')} (${
    market.productVariants?.shoeSizeStandard
  })`;
};

export const createNewSelection = (
  variant: string | null,
  variantSelection: VariantSelection
) => {
  const currentSelection = variantSelection ?? [];
  if (!variant) {
    return null;
  }
  const newSelection = currentSelection.includes(variant)
    ? currentSelection.filter((v: string) => v !== variant)
    : [...currentSelection, variant];
  return newSelection.length ? newSelection : null;
};

export const getFractalRepresentation = (numericString: string) => {
  const integerValue = parseInt(numericString, 10);
  const decimalValue = parseFloat(numericString) % 1;
  if (isNaN(integerValue) || isNaN(decimalValue)) {
    return numericString;
  }
  if (decimalValue > 0.4 && decimalValue < 0.6) {
    return `${integerValue} ½`;
  }
  if (decimalValue > 0.25 && decimalValue < 0.4) {
    return `${integerValue} ⅓`;
  }
  if (decimalValue > 0.6 && decimalValue < 0.75) {
    return `${integerValue} ⅔`;
  }
  return numericString;
};
